



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { FaxLine } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService,userService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveFaxLinexPage extends Base {
  public storeId: number = 0;
  public form: any = {};
  public faxnumber: string = '';
  public faxLineFields: Array<VFields<any>> = [];
  public requestProgress: boolean = false;
  public faxLineModel: FaxLine = {
    id: '',
    faxNumber: '',
    assignedUsers: [],
  };
  public userList: any[] = [];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Fax' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.faxLines.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveFaxLine();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.faxId) {
      this.faxnumber = this.$route.params.faxId;
    }
    this.setFaxFields();
    if (this.$route.params.storeId) {
      this.getStoreInfo();
      this.getUsers();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setFaxFields(): void {
    this.faxLineFields = [
      {
        key: 'faxNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.faxLines.lblEnterTwilioFaxEnabledNumber'
          ) as string,
          loading: false,
        },
      },
      {
        key: 'assignedUsers',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$t('stores.faxLines.lblSelectAssignedUsers') as string,
          multiple: true,
          required: true,
          items: this.userList,
          text: 'text',
          value: 'id',
          disabled: false,
          altag: 'Select Assigned Users',
          loading: false,
          rules:[
            v => this.requiredForArray('Select Assigned Users',v)
          ]
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.faxLineFields);
      const response = await storeService.getStore(this.storeId);
      const selectedFaxLine = response.storeJson.faxLines.find(
        (m) => m.id === this.$route.params.faxId
      );
      if (this.faxnumber) {
        this.faxLineModel.id = selectedFaxLine.id;
        this.faxLineModel.faxNumber = selectedFaxLine.faxNumber;
        this.faxLineModel.assignedUsers = selectedFaxLine.assignedUsers
          ? selectedFaxLine.assignedUsers
          : [];
      }
    } finally {
      this.formlyHideSkeleton(this.faxLineFields);
    }
  }

  public async getUsers(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.faxLineFields, 'assignedUsers');
      const response = await userService.getStoreUsersListAsync();
      this.userList = response.results;
      this.setFaxFields();
    } finally {
      this.formlyHideSkeleton(this.faxLineFields, 'assignedUsers');
    }
  }

  public validateFaxline(): Vue & { validate: () => boolean } {
    return this.$refs.faxlineForm as Vue & { validate: () => boolean };
  }

  public async saveFaxLine(): Promise<void> {
    if(this.validateFaxline().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.faxLineModel.id === '') {
          await storeService.saveFaxLine(
            this.storeId,
            this.faxnumber,
            this.faxLineModel
          );
          this.showAlert(true, this.$t('stores.faxLines.alertFaxLineAdded'));
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'Fax'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updateFaxLine(
            this.storeId,
            this.faxnumber,
            this.faxLineModel
          );
          this.showAlert(true, this.$t('stores.faxLines.alertFaxLineUpdated'));
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab:'Fax'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
